
import CryptoJS from './aes';
// import { message } from 'antd';
// import logHelper from './logHelper';

const encrypt=(plainText, key)=>{
    // 16 bytes of random number
    let fin=CryptoJS.lib.WordArray.random(16);
    // Generate an IV
    let iv=fin.clone();
    let encrypted=CryptoJS.AES.encrypt(plainText, key, { iv:iv });
    fin.concat(encrypted.ciphertext);
    let base64=fin.toString(CryptoJS.enc.Base64);
    // Change to the URL and filename safe alphabet
    return base64.replace(/\+/g, "-").replace(/\//g, "_");
}
const pad=(n)=>{
    return (n<10 ? "0"+n : n);
}
const getDateTimeString=(date)=>{
    return "" + date.getUTCFullYear() + pad(date.getUTCMonth() + 1) + pad(date.getUTCDate()) +
           pad(date.getUTCHours()) + pad(date.getUTCMinutes()) + pad(date.getUTCSeconds());
}
const chunkArray=(array, chunkSize)=> {  
    let chunkedArray = [];  
    for (let i = 0; i < array.length; i += chunkSize) {  
        chunkedArray.push(array.slice(i, i + chunkSize));  
    }  
    return chunkedArray;  
}
const Utils={
    fids:[6,11,12,13,16,19,21,22,25,30,31,32,35,56,380,1465,3265,3266,32741,3372,3404,3854,14266],
    wdsprovision:{
        request:async (rics)=>{
            // let url = new URL(process.env.REACT_APP_WDSCONFIG_API);  
            // let api=process.env.NODE_ENV=='development'?url.pathname:url;
            let api=process.env.REACT_APP_WDSCONFIG_API;
            let params = new URLSearchParams();  
            params.append('company', process.env.REACT_APP_WDSCONFIG_COMPANY);  
            params.append('rics', rics.join(';'));
            params.append('token', process.env.REACT_APP_WDSCONFIG_TOKEN);  
            let resp=await fetch(api+'?'+params.toString(),{method: 'GET', headers: {'Content-Type': 'application/json'}}).then((resp)=>{
                return resp.json();
            });
            return resp;
        },
    },
    generateLoginToken:()=>{
        let token="wds," + getDateTimeString(new Date()) + "," + process.env.REACT_APP_WDSCONFIG_USERID;
        return encrypt(token, CryptoJS.enc.Base64.parse(process.env.REACT_APP_WDSCONFIG_AES_KEY));
    }
}

class SocketItem {
    constructor(host,cb) {
        this.host=host;
        this.auth=false;
        this.lockLogin = false;
        this.authCb=cb;
        this.historyData={service:'',rics:[]};
        this.liveTime=new Date().getTime();
        this.dataTime=new Date().getTime();
        this.socket=new WebSocket(`wss://${host}/wds/rt`);
        this.socket.onopen=(event) => this._onopen(event); 
        this.socket.onmessage= (event) => this._onmessage(event);
        this.socket.onclose=(event) => this._onclose(event); 
        this.socket.onerror=(event) => this._onerror(event);
    }
    subscribe(rics,service,ticket){
        if(rics.length<=0) return;
       // this.unsubscribe(rics); 
        this.historyData={service,rics};
        let req6={ type:"request", service, rics, fids:Utils.fids, ticket };
        this._send(JSON.stringify(req6));
    }
    unsubscribe(rics){
        let newRics=rics.filter(ric=>this.historyData.rics.indexOf(ric) != -1);
        if(newRics.length<=0) return;
        let req6={ type:"cancel", service:this.historyData.service, rics:newRics };
        this._send(JSON.stringify(req6));
    }
     logout(){
        if(this.socket==null) return;
        this.socket.close(1000, "logout");
    }
    getState(){
        //CONNECTING=连接正在建立中,OPEN=连接已建立，可以进行通信,CLOSING=连接正在关闭中,CLOSED=连接已关闭或无法打开
        if(this.socket==null) return "CLOSED";
        if(this.socket.readyState==0) return 'CONNECTING';
        if(this.socket.readyState==1) return 'OPEN';
        else if(this.socket.readyState == 2) return 'CLOSING';
        else if(this.socket.readyState == 3) return 'CLOSED';
        return 'unknown';
    }
     _onopen(event){
        this.lockLogin = false;
        let login={ type:"login",company:process.env.REACT_APP_WDSCONFIG_COMPANY, conflate:3000,token:Utils.generateLoginToken() };
        this._send(JSON.stringify(login));
    }
     _onmessage(event){
        let resp = JSON.parse(event.data);
        if (resp.type === "live") {
            this.liveTime = new Date().getTime();
            if (!this.auth){
                this.auth=true;
                this.authCb?.(this);
            }
        }
        else if (resp.type === "update") {
            this.dataTime = new Date().getTime();
            let serviceItem=resp.data[this.historyData.service];
            if(serviceItem==null) return;
            let ricItem=serviceItem[Object.keys(serviceItem)[0]];
            if(ricItem==null) return;
            // logHelper.write(`收到socket msg:${Object.keys(resp.data).length}`);
            let newServiceItem={};
            for(var key in serviceItem){
                 let pkey=key.indexOf('/') != -1?key.replace('/',''):key;
                 newServiceItem[pkey]=serviceItem[key];
            }
           // console.log(newServiceItem,'ricItem');
            const detail = { rawData: resp.data, formatData:newServiceItem,dataTime:this.dataTime};  
            const event = new CustomEvent('wds:message', { detail });  
            document.dispatchEvent(event);  
        }
    }
     _onclose(event){
        this.auth=false;
        this.socket=null;
        this.lockLogin = false;
    }
     _onerror(){
        this.auth=false;
        this.socket=null;
        this.lockLogin = false;
    } 
    _send(msg){
        if( this.socket==null ||  this.socket.readyState != WebSocket.OPEN) return;
        this.socket.send(msg);
    }
}
const WDS_STATES_TO_RECONNECT = ['CLOSING', 'CLOSED'];
const RECONNECT_THRESHOLD_SECONDS = 50;
const TICK_INTERVAL = 5000;
class SocketClient{
    constructor() {
        this.wsMap={};
        this.ricList=[];
        this.tickTimer=null;
        this.lockTick=false;
    }
     subscribe=async (rics)=>{
        if(rics.length<=0) return;
        let combinedArray = this.ricList.concat(rics);  
        this.ricList= [...new Set(combinedArray)];  
        let resp=await Utils.wdsprovision.request(this.ricList);
        if(resp.ticketList==null || resp.ticketList.length<=0){
            console.log('No available ticketList');
            return Promise.resolve(false);
        }
        resp.ticketList.map((ticketInfo)=>{
            let ws = this.wsMap[ticketInfo.host];
            if(ws==null){
                console.log(ticketInfo.rics,ticketInfo.service,ticketInfo.ticket);
                ws=new SocketItem(ticketInfo.host,(ref)=>{
                    ref.subscribe(ticketInfo.rics,ticketInfo.service,ticketInfo.ticket);
                });
                this.wsMap[ticketInfo.host]=ws;
            }else{
                ws.subscribe(ticketInfo.rics,ticketInfo.service,ticketInfo.ticket);
            }
        })
       return Promise.resolve(true);
     }
      unsubscribe=(rics)=>{
        if(rics.length<=0) return;
        for(var host in this.wsMap){
            this.wsMap[host].unsubscribe(rics);
        }
        this.ricList=this.ricList.filter(item => rics.indexOf(item) === -1);
      }
       /***
       * rics:[{ric：'SOXL.NB'，marker:'US', isRequestDelayedData:false},......]
       * marker:US,JPN,HK
       ***/
      subscribe2=async (rics)=>{
        if(rics.length<=0) return;
        let myRics=rics.map((item)=>{
            if(item.isRequestDelayedData){
                // return item.marker==='JPN'?item.ric+'d':'/'+item.ric;
                return `/${item.ric}`;
            }
            return item.ric;
        })
        console.log(myRics);
        let combinedArray = this.ricList.concat(myRics);  
        this.ricList= [...new Set(combinedArray)];  
        let resp=await Utils.wdsprovision.request(this.ricList);
        if(resp.ticketList==null || resp.ticketList.length<=0){
            console.log('No available ticketList');
            return Promise.resolve(false);
        }
        resp.ticketList.map((ticketInfo)=>{
            let ws = this.wsMap[ticketInfo.host];
            if(ws==null){
                ws=new SocketItem(ticketInfo.host,(ref)=>{
                    ref.subscribe(ticketInfo.rics,ticketInfo.service,ticketInfo.ticket);
                });
                this.wsMap[ticketInfo.host]=ws;
            }else{
                ws.subscribe(ticketInfo.rics,ticketInfo.service,ticketInfo.ticket);
            }
        })
         return Promise.resolve(true);
      }
         /***
       * rics:[{ric：'SOXL.NB'，marker:'US', isRequestDelayedData:false},......]
       * marker:US,JPN,HK
       ***/
      unsubscribe2=(rics)=>{
        if(rics.length<=0) return;
        let myRics=rics.map((item)=>{
            if(item.isRequestDelayedData){
                //return item.marker==='JPN'?item.ric+'d':'/'+item.ric;
                return `/${item.ric}`;
            }
            return item.ric;
        })
        for(var host in this.wsMap){
            this.wsMap[host].unsubscribe(myRics);
        }
        this.ricList=this.ricList.filter(item => myRics.indexOf(item) === -1);
      }
      logout=()=>{
        for(var host in this.wsMap){
            this.wsMap[host].logout();
        }
        this.wsMap={};
        this.ricList=[];
        this.tickTimer=null;
        this.lockTick=false;
      }
      tick=()=>{
            this.clearTick();
            let needSubscribe = false;
            for (let host in this.wsMap) {
                let ws=this.wsMap[host];
                let cur_time = new Date().getTime();
                let live_diff_sec = (cur_time - ws.liveTime) / 1000;
                let data_diff_sec = (cur_time - ws.dataTime) / 1000;
                if((live_diff_sec>RECONNECT_THRESHOLD_SECONDS && data_diff_sec>RECONNECT_THRESHOLD_SECONDS) 
                    ||  WDS_STATES_TO_RECONNECT.includes(ws.getState())){ 
                    ws.logout();
                    delete this.wsMap[host];
                    needSubscribe = true;
                    break;
                }
                console.log(needSubscribe,ws.liveTime, ws.dataTime,ws.getState(),'tick')
            }
            if(needSubscribe && !this.lockTick){
                this.lockTick=true;
                this.subscribe(this.ricList).then((result)=>{
                    this.lockTick=false;
                });
            }
            this.tickTimer=setTimeout(() => {
                this.tick();
            }, TICK_INTERVAL);
            return this.tickTimer;
      }
      clearTick=()=>{
        if(this.tickTimer){
           clearTimeout(this.tickTimer);
         }
      }

}

let WDSInstance;
if (!WDSInstance) {
    WDSInstance =new SocketClient();
    // WDSInstance.tick();
    console.log('create sockets instance',WDSInstance);
}
export default WDSInstance;


